export const isAdminAndVisitingAddressSame = (company: server.dto.Company): boolean =>
  (company.address.formatted.every((addressLine, idx) => company.admAddress.formatted[idx] === addressLine)) && company.name === company.admName;

/**
 * @deprecated This should not be used. We should not convert betweend CompanySmall and ArtistSmall instead we should just use ArtistSmall
 **/
export const companyToArtist = (company: server.dto.CompanySmall | server.dto.Company): server.dto.ArtistSmall => {
  if (company == null) return undefined;

  return {
    artistId: company.companyId,
    name: company.name,
  }
}



/**
 * @deprecated This should not be used. We should not convert betweend CompanySmall and VenueSmall instead we should just use VenueSmall
 **/
export const venueToCompany = (venue: server.dto.VenueSmall): server.dto.CompanySmall => {
  if (venue == null) return undefined;

  return {
    companyId: venue.venueId,
    name: venue.name,
    cityCountry: venue.cityCountry,
    isValidated: venue.isValidated,
    address: []
  }
}

/**
 * @deprecated This should not be used. We should not convert betweend CompanySmall and VenueSmall instead we should just use VenueSmall
 **/
export const companyToVenue = (company: server.dto.CompanySmall, venueLocation: server.dto.Geo): server.dto.VenueSmall => {
  if (company == null) return undefined;

  return {
    venueId: company.companyId,
    name: company.name,
    cityCountry: company.cityCountry,
    location: venueLocation,
    isValidated: company.isValidated,
  }
}

export const toCompanySmall = (company: server.dto.Company): server.dto.CompanySmall => {
  if (company == null) return undefined;

  return {
    companyId: company.companyId,
    name: company.name,
    cityCountry: [company.address.city, company.address.countryName].filter(Boolean).join(", "),
    isValidated: company.isValidated,
    address: company.address.formatted
  }
}